import { StylesConfig } from 'react-select';
import { IReportSelectedUser } from '../../common/models/user/IReportSelectedUser';

export const getUser = (item: IReportSelectedUser) => (item.initials
  ? item
  : { initials: item.email[0].toUpperCase() });

export const selectStyles: StylesConfig = {
  input: provided => ({
    ...provided,
    fontSize: '1rem',
    fontFamily: 'Inter',
    color: 'var(--neutral-800)'
  }),
  control: (_provided, state) => ({
    border: 'none',
    borderBottom: `2px solid ${state.isFocused ? 'var(--primary-600)' : 'var(--neutral-200)'}`,
    boxShadow: 'none',
    background: 'transparent',
    display: 'flex'
  }),
  valueContainer: provided => ({ ...provided, padding: 0 })
};
